import { BaseRequest, IBaseRequest } from '../../BaseRequest';
import { Filter, toFilterXml } from '../../dataObjects/Filter';
import { Order, toOrderXml } from '../../dataObjects/Order';

export interface IListTimelineRequest extends IBaseRequest {
    limit?:        string;
    offset?:       string;
    orderBy?:      string;
    countOnly?:    string;
    contextRoot?:  string;
    includeSlave?: string;
    FILTER?:       Filter;
    ORDER?:        Order;
}

export class ListTimelineRequest extends BaseRequest implements IListTimelineRequest {

    public limit?:        string;
    public offset?:       string;
    public orderBy?:      string;
    public countOnly?:    string;
    public contextRoot?:  string;
    public includeSlave?: string;
    public FILTER?:       Filter;
    public ORDER?:        Order;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.orderBy = otherOptions.orderBy;
        this.countOnly = otherOptions.countOnly;
        this.contextRoot = otherOptions.contextRoot;
        this.includeSlave = otherOptions.includeSlave;
        this.FILTER = otherOptions.FILTER;
        this.ORDER = otherOptions.ORDER
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.orderBy, 'orderBy');
        parameters += this.makeNode(this.countOnly, 'countOnly');
        parameters += this.makeNode(this.contextRoot, 'contextRoot');
        parameters += this.makeNode(this.includeSlave, 'includeSlave');
        if (this.FILTER) parameters += toFilterXml(this.FILTER);
        if (this.ORDER) parameters += toOrderXml(this.ORDER);

        return super.wrapperXml('ListTimeline', parameters);
    }
}
